module.exports = __webpack_public_path__ + "img/27a9436da986d5c624ea896e87b71707.png";